<template>
  <div class="content o checkout">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <nav aria-label="breadcrumb" role="navigation" class="m-0 px-4">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'Search' }"> Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Checkout
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1 class="section_header px-4">Checkout</h1>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <PulseLoader :loading="loading" :class="{ hide: !loading }"
          quote="Action is the foundational key to all success" author="Pablo Picasso" profession="Spanish Painter"
          img="picasso.jpg"></PulseLoader>
        <div class="checkout-wrap" v-if="!loading">
          <div class="checkout-card">
            <span class="checkout-title">Checkout</span>
            <div class="md-layout" v-if="cart.length">
              <div class="md-layout-item md-size-50 mt-4">
                <md-table v-model="cart" class="table-shopping">
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Product" class="tabel-product">
                      <h4><b>{{ item.name }}</b></h4>
                    </md-table-cell>
                    <md-table-cell md-label="Description" class="td-name product">
                      <p v-if="item.area">Area: {{ item.area }}</p>
                      <p>Details: {{ item.details }}</p>
                    </md-table-cell>
                    <md-table-cell md-label="Price" class="price">
                      <sup>$</sup>{{ item.price }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <div class="table table-stats">
                  <div class="td-price">
                    <span class="total-label md-display-1 total">Total</span>
                    <div class="td-total"><sup>$</sup>{{ total }}</div>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-size-50">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <div class="section-title">Billing Information</div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-field :class="{
                      'md-invalid': $v.billingFirstname.$error,
                    }">
                      <label>
                        Billing First Name
                      </label>
                      <md-input v-model="$v.billingFirstname.$model" type="text"></md-input>
                      <span class="md-error" v-if="!$v.billingFirstname.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field :class="{
                      'md-invalid': $v.billingLastname.$error,
                    }">
                      <label>
                        Billing Last Name
                      </label>
                      <md-input v-model="$v.billingLastname.$model" type="text"></md-input>
                      <span class="md-error" v-if="!$v.billingLastname.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field :class="{
                      'md-invalid': $v.billingemailAddress.$error,
                    }">
                      <label>
                        Billing Email
                      </label>
                      <md-input v-model="$v.billingemailAddress.$model" type="email"></md-input>
                      <span class="md-error" v-if="!$v.billingemailAddress.required">This field is required.</span>
                      <span class="md-error" v-if="!$v.billingemailAddress.email">You must input email.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field :class="{
                      'md-invalid': $v.billingPhone.$error,
                    }">
                      <label>
                        Billing Phone
                      </label>
                      <md-input v-model="$v.billingPhone.$model" type="phone"></md-input>
                      <span class="md-error" v-if="!$v.billingPhone.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-size-100">
                    <div class="section-sub-title">Billing Address</div>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-50 billing-address-section">
                    <md-field :class="{
                      'md-invalid': $v.billingAddressCity.$error,
                    }">
                      <label>
                        City
                      </label>
                      <md-input v-model="$v.billingAddressCity.$model" type="text"></md-input>
                      <span class="md-error" v-if="!$v.billingAddressCity.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-50">
                    <md-field :class="{
                      'md-invalid': $v.billingAddressCountry.$error,
                    }">
                      <label>
                        Country
                      </label>
                      <country-select v-model="$v.billingAddressCountry.$model"
                        :country="$v.billingAddressCountry.$model" topCountry="US" />
                      <span class="md-error" v-if="!$v.billingAddressCountry.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-50">
                    <md-field :class="{
                      'md-invalid': $v.billingAddressPostalCode.$error,
                    }">
                      <label>
                        Postal Code
                      </label>
                      <md-input v-model="$v.billingAddressPostalCode.$model" type="text"></md-input>
                      <span class="md-error" v-if="!$v.billingAddressPostalCode.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-50">
                    <md-field :class="{
                      'md-invalid': $v.billingAddressState.$error,
                    }">
                      <label>
                        State/Province
                      </label>
                      <region-select v-model="$v.billingAddressState.$model" :country="$v.billingAddressCountry.$model"
                        :region="$v.billingAddressState.$model" />
                      <span class="md-error" v-if="!$v.billingAddressState.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field :class="{
                      'md-invalid': $v.billingAddressLine1.$error,
                    }">
                      <label>
                        Address Line 1
                      </label>
                      <md-input v-model="$v.billingAddressLine1.$model" type="text"></md-input>
                      <span class="md-error" v-if="!$v.billingAddressLine1.required">This field is required.</span>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field :class="{
                      'md-invalid': billingAddressLine2,
                    }">
                      <label>
                        Address Line 2
                      </label>
                      <md-input v-model="billingAddressLine2" type="text"></md-input>
                      <!-- <span
                        class="md-error"
                        v-if="!$v.billingAddressLine2.required"
                      >This field is required.</span> -->
                    </md-field>
                  </div>
                </div>

                <div class="md-layout-item md-small-size-100 md-size-100">
                  <div class="section-title">Payment Information</div>
                </div>
                <!-- <StripeCheckout pk="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" :lineItems="cart" :items="cart" mode="payment" successUrl="https://bizminer.com" cancelUrl="https://bizminer.com" :clientReferenceId="user.id" :customerEmail="user.email" submitType="pay" /> -->
                <div class="md-layout-item md-size-100">
                  <!-- <label>Card Number</label>
                  <div id="card-number"></div>
                  <label>Card Expiry</label>
                  <div id="card-expiry"></div>
                  <label>Card CVC</label>
                  <div id="card-cvc"></div>
                  <div id="card-error"></div> -->
                  <div>
                    <stripe-element-payment ref="paymentRef" :pk="pk" :elements-options="elementsOptions"
                      :confirm-params="confirmParams" locale="en" />
                    <!-- <button @click="pay">Pay Now</button> -->
                  </div>
                  <div class="text-right saveBtn">
                    <md-button type="button" id="custom-button" @click="pay"
                      :class="processing ? 'md-raised md-info md-round mt-4 non-subscriber no-click' : 'md-raised md-info md-round mt-4'">
                      {{ processing ? 'Processing' : 'Checkout' }}</md-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout" v-if="!cart.length">
              <div class="md-layout-item md-size-100 mt-4 text-center">
                <div class="section-title">Cart is empty</div>
                <router-link :to="{ name: 'Search' }">
                  <md-button type="button" id="custom-button" @click="createToken"
                    class="md-raised md-info md-round mt-4">Return to Dashboard</md-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PulseLoader } from '@/components';
import { mapState } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
import { StripeElementPayment } from '@vue-stripe/vue-stripe';

export default {
  components: {
    StripeElementPayment,
    PulseLoader
  },
  data() {
    return {
      productsID: null,
      processing: false,
      loading: true,
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      customerId: null,
      billingFirstname: null,
      billingLastname: null,
      billingemailAddress: null,
      billingAddressCity: null,
      billingAddressCountry: null,
      billingAddressLine1: null,
      billingAddressLine2: null,
      billingAddressPostalCode: null,
      billingAddressState: null,
      billingPhone: null,
      pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      elementsOptions: {
        appearance: {}, // appearance options
      },
      confirmParams: {
        return_url: process.env.VUE_APP_BASE_URL + '/checkout-success', // success url
      },
      paymentIntentId: null
    };
  },
  validations: {
    billingFirstname: {
      required,
    },
    billingLastname: {
      required,
    },
    billingAddressCity: {
      required,
    },
    billingAddressCountry: {
      required,
    },
    billingAddressLine1: {
      required,
    },
    // billingAddressLine2: {
    //   required,
    // },
    billingAddressPostalCode: {
      required,
    },
    billingAddressState: {
      required,
    },
    billingPhone: {
      required
    },
    billingemailAddress: {
      required,
      email,
    },
  },
  computed: {
    ...mapState({
      cart: (state) => {
        let cart = state.cart.cart;
        cart.forEach(item => {
          item.quantity = 1;
        });

        return cart;
      },
      stripeElements() {
        return this.$stripe.elements();
      },
      user: (state) => state.user,
      subTotal: (state) => state.cart.subTotal,
      total: (state) => state.cart.total,
    }),
    shoppingTotal() {
      return this.shoppingCartTable.reduce((accumulator, current) => {
        return accumulator + current.amount;
      }, 0);
    },
  },
  methods: {
    getAlignClasses: ({ id }) => ({
      'text-right': id,
    }),
    computeAmount(item) {
      item.amount = item.qty * item.price;
    },
    async createToken() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const { token, error } = await this.$stripe.createToken(this.cardNumber);
      if (error) {
        // handle error here
        document.getElementById('card-error').innerHTML = error.message;
        return;
      }
      // handle the token
      // send it to your server
      let params = {
        billingFirstname: this.billingFirstname,
        billingLastname: this.billingLastname,
        billingemailAddress: this.billingemailAddress,
        billingAddressCity: this.billingAddressCity,
        billingAddressCountry: this.billingAddressCountry,
        billingAddressLine1: this.billingAddressLine1,
        billingAddressLine2: this.billingAddressLine2,
        billingAddressPostalCode: this.billingAddressPostalCode,
        billingAddressState: this.billingAddressState,
        billingPhone: this.billingPhone,
        total: this.total,
        stripeToken: token,
      }

      await this.$store.dispatch('checkout/stripeCheckout', params).then((res) => {
        this.loading = false;

        if (res.success) {
          this.$router.push({
            name: 'CheckoutSuccess'
          });
        }
      });
    },
    async getCart() {
      await this.$store.dispatch('cart/list').then(async (res) => {
        if (this.cart.length) {
          await this.generatePaymentIntent();
          this.initStripe();
        } else {
          this.loading = false;
        }
      });
    },
    async generatePaymentIntent() {
      await this.$store.dispatch('cart/list').then(async (res) => {
        if (!res.items || !res.items.length) {
          this.cart = [];
          return false;
        }

        let params = {
          total: this.total,
        }

        const paymentIntent = await this.$store.dispatch('checkout/stripePaymentIntent', params).then((res) => {
          let clientSecret = res.paymentIntent.client_secret;
          this.customerId = res.paymentIntent.customer;
          this.paymentIntentId = res.paymentIntent.id;
          this.elementsOptions.clientSecret = clientSecret;
          this.loading = false;
          let productsAux = '';
          res.cartItems.forEach(el => {
            productsAux = `${productsAux}${el.profile_id},`;
          })

          this.productsID = productsAux;
          // this.loading = false;

          // if (res.success) {
          //   this.$router.push({
          //     name: 'CheckoutSuccess'
          //   });
          // }
        }); // this is just a dummy, create your own API call
        // this.elementsOptions.clientSecret = paymentIntent.client_secret;
      });
    },
    async pay() {
      this.processing = true;
      let params = {
        customerId: this.customerId,
        billingFirstname: this.billingFirstname,
        billingLastname: this.billingLastname,
        billingemailAddress: this.billingemailAddress,
        billingAddressCity: this.billingAddressCity,
        billingAddressCountry: this.billingAddressCountry,
        billingAddressLine1: this.billingAddressLine1,
        billingAddressLine2: this.billingAddressLine2,
        billingAddressPostalCode: this.billingAddressPostalCode,
        billingAddressState: this.billingAddressState,
        billingPhone: this.billingPhone,
        paymentIntentId: this.paymentIntentId
      }
      await this.$store.dispatch('checkout/stripePaymentIntentUpdate', params).then((res) => {
        this.loading = false;
        this.$refs.paymentRef.submit();
        PostAffTracker.setAccountId(this.customerId);

        var sale = PostAffTracker.createSale();
        sale.setTotalCost(this.total);
        sale.setOrderID(this.paymentIntentId);
        sale.setProductID(this.productsID);

        PostAffTracker.register();
       
      });

    },
    async initStripe() {
      // Style Object documentation here: https://stripe.com/docs/js/appendix/style
      const style = {
        base: {
          color: '#3c4858',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '14px',
          '::placeholder': {
            color: '#aab7c4',
          },
          border: '1px solid #d9d9d9',
          padding: '0 15px',
          lineHeight: '34px'
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      };

      setTimeout(async function () {
        this.cardNumber = await this.stripeElements.create('cardNumber', { style });
        this.cardNumber.mount('#card-number');
        this.cardExpiry = await this.stripeElements.create('cardExpiry', { style });
        this.cardExpiry.mount('#card-expiry');
        this.cardCvc = await this.stripeElements.create('cardCvc', { style });
        this.cardCvc.mount('#card-cvc');

        this.billingFirstname = this.user.user.firstNameBilling;
        this.billingLastname = this.user.user.lastNameBilling;
        this.billingemailAddress = this.user.user.emailBilling;
        this.emailAddress = this.user.user.email;
      }.bind(this), 2000)

      this.loading = false;
    }
  },
  async created() {
  },
  async mounted() {
    this.loading = true;
    this.getCart();
  },
  beforeDestroy() {
    if (this.cardNumber) {
      this.cardNumber.destroy();
    }
    if (this.cardExpiry) {
      this.cardExpiry.destroy();
    }
    if (this.cardCvc) {
      this.cardCvc.destroy();
    }
  },
};
</script>
<style lang="scss">
</style>
